'use client';

import { useEffect, useState } from 'react';
import { useMediaQuery } from 'usehooks-ts';
import 'aos/dist/aos.css'; // 导入AOS样式

export default function AOSProvider({ children }) {
  const desktop = useMediaQuery('(min-width: 834px)');
  const [aosLoaded, setAosLoaded] = useState(false);

  useEffect(() => {
    // 检测设备类型
    const isMobile = window.innerWidth < 768;

    // 根据设备类型设置不同的延迟时间
    const delayTime = isMobile ? 2000 : 1000; // 移动端延迟2秒，PC端1秒

    // 延迟加载 AOS，避免阻塞首屏渲染
    const timer = setTimeout(() => {
      import('aos')
        .then((AOS) => {
          AOS.init({
            offset: desktop ? 300 : 200,
            duration: isMobile ? 800 : 1000, // 移动端动画更快
            once: true, // 动画只执行一次，提升性能
            mirror: false,
            disable: false, // 所有设备都启用动画
            startEvent: 'DOMContentLoaded', // 确保DOM加载完成
            initClassName: 'aos-init', // 初始化类名
            animatedClassName: 'aos-animate', // 动画类名
          });
          setAosLoaded(true);

          // 保存到 window 以供其他地方使用
          window.AOS = AOS;

          console.log(isMobile ? '📱 移动端AOS已加载' : '💻 PC端AOS已加载');

          // 检查并输出AOS元素数量
          const checkAOSElements = () => {
            const elements = document.querySelectorAll('[data-aos]');
            console.log(`📊 检测到 ${elements.length} 个AOS元素`);
            return elements.length;
          };

          checkAOSElements();

          // 延迟刷新AOS，确保懒加载的组件也能被检测到
          setTimeout(() => {
            if (window.AOS) {
              window.AOS.refresh();
              const count = checkAOSElements();
              console.log(`🔄 AOS已刷新，当前有 ${count} 个元素`);
            }
          }, 1000); // 再等1秒让懒加载组件渲染完成

          // 再次刷新（确保所有懒加载组件都加载完）
          setTimeout(() => {
            if (window.AOS) {
              window.AOS.refresh();
              const count = checkAOSElements();
              console.log(`🔄 AOS二次刷新，当前有 ${count} 个元素`);
            }
          }, 3000);
        })
        .catch((error) => {
          console.warn('Failed to load AOS:', error);
        });
    }, delayTime);

    return () => clearTimeout(timer);
  }, [desktop]);

  return <>{children}</>;
}
